import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardText, Form, Container, Button, Alert,   ButtonDropdown, Modal,
    DropdownToggle,
    DropdownMenu,
    DropdownItem, } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { useHistory } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import * as url from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Timeline from './Timeline';

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'

    const IPAAdd = () => {
        const history = useHistory();
        const [apType , setApType] = useState(['Annual', 'Probation'])

        const [btnprimary1, setBtnprimary1] = useState(false)
        const [inputs, setInputs] = useState([]);
        const [empNo, setEmpNo] = useState('');
        const [empName, setEmpName] = useState('');
        const [empTitle, setEmpTitle] = useState('');
        const [startDate, setStartDate] = useState('');
        const [endDate, setEndDate] = useState('');
        const [type, setType] = useState('');
        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [ipaSaved, setIpaSaved] = useState(false)
        const [ipaNo, setIpaNo] = useState('')

        const [supervisorNo, setSupervisorNo] = useState('')
        const [supervisorName, setSupervisorName] = useState('')
        const [supervisorTitle, setSupervisorTitle] = useState('')

        const [ipaLines1, setIpaLines1] = useState([])
        const [ipaLines2, setIpaLines2] = useState([])
        const [ipaLines3, setIpaLines3] = useState([])
        const [ipaLines4, setIpaLines4] = useState([])

        const [kra, setKra] = useState('')
        const [target, setTarget] = useState('')
        const [kpi, setKpi] = useState('')
        const [resources, setResources] = useState('')

        const [cCode, setCCode] = useState('')
        const [competenciesDescription, setCompetenciesDescription] = useState('')
        const [attributes, setAttributes] = useState('')
        const [kpi2, setKpi2] = useState('')
        const [resources2, setResources2] = useState('')

        const [support, setSupport] = useState('')
        const [plannedResults, setPlannedResults] = useState('')
        const [actualResults, setActualResults] = useState('')

        const [goal, setGoal] = useState('')
        const [method, setMethod] = useState('')
        const [application, setApplication] = useState('')

        toastr.options = TOAST_OPTIONS;

        const [modal_ipa1, setmodal_ipa1] = useState(false)
        const [modal_ipa2, setmodal_ipa2] = useState(false)
        const [modal_ipa3, setmodal_ipa3] = useState(false)
        const [modal_ipa4, setmodal_ipa4] = useState(false)

        const [CompanyID, setCompanyID] = useState("")

        const [competencies, setCompetencies] = useState([])
        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_ipa1 = () => {
            setmodal_ipa1(!modal_ipa1);
            removeBodyCss();
        }
        const tog_ipa2 = () => {
            setmodal_ipa2(!modal_ipa2);
            removeBodyCss();
        }
        const tog_ipa3 = () => {
            setmodal_ipa3(!modal_ipa3);
            removeBodyCss();
        }
        const tog_ipa4 = () => {
            setmodal_ipa4(!modal_ipa4);
            removeBodyCss();
        }
        const addIPA1 = () =>{
            const line ={
                "KeyResultArea": kra,
                "StatementofTargettobeachieved": target,
                "KeyPerformanceIndicator": kpi,
                "ResourcesandSupportRequiredforachievementsettargetsandgoals": resources
            }
            setIpaLines1(state =>[...state, line])
            tog_ipa1()
            setKra('')
            setTarget('')
            setKpi('')
            setResources('')
        }
        const remove1 = (k)=>{
            const newItems = [...ipaLines1];
            newItems.splice(k, 1);
            setIpaLines1(newItems);
        }
        const remove2 = (k)=>{
            const newItems = [...ipaLines2];
            newItems.splice(k, 1);
            setIpaLines2(newItems);
        }
        const remove3 = (k)=>{
            const newItems = [...ipaLines3];
            newItems.splice(k, 1);
            setIpaLines3(newItems);
        }
        const remove4 = (k)=>{
            const newItems = [...ipaLines4];
            newItems.splice(k, 1);
            setIpaLines4(newItems);
        }
        const addIPA2 = () =>{
            const line = {
                "CompetenceCode": cCode,
                //"competenciesDescription": competenciesDescription,
                "CriticalAttributestargetedundereachcompetence": attributes,
                "KeyPerformanceIndicator": kpi2,
                "ResourcesandSupportRequiredforachievementsettargetsandgoals": resources2
            }
            setIpaLines2(state =>[...state, line])
            tog_ipa2()
            setCCode('')
            setCompetenciesDescription('')
            setAttributes('')
            setKpi2('')
            setResources2('')
        }
        const addIPA3 = () =>{
            const line = {
                "Supportthosereportingtoyoutoimplementthisyearsperformanceandlearninganddevelopmentobjectives": support,
                "PlannedResultsWhatwastheindicatorofCoachingresults": plannedResults,
                "ActualCoachingResultsWhatwasachievedandimpact": actualResults
            }
            setIpaLines3(state =>[...state, line])
            tog_ipa3()
            setSupport('')
            setPlannedResults('')
            setActualResults('')
        }
        const addIPA4 = () =>{
            const line = {
                "DevelopmentGoalsIdentifiedlearningdevelopmentareas": goal,
                "LearningDevelopmentMethodsHowwilltheLearningandDevelopmentbeachieved": method,
                "ApplicationWhatistheexpectedchangeinperformanceafteracquiringtheidentifiedskills": application
            }
            setIpaLines4(state =>[...state, line])
            tog_ipa4()
            setGoal('')
            setMethod('')
            setApplication('')
        }
        const handleChange = (event) => {
             const name = event.target.name;
             const value = event.target.value;
             setInputs(values => ({...values, [name]: value}));
        }
        const handleSaveIPA = () => {
            setIsloading(true);
            const data = {
                "EmployeeNo": empNo,
                "FromDate"  : formatDate(startDate),
                "ToDate"    : formatDate(endDate),
                "TypeofPerformanceAppraisal": type,
                "ipaLines"  : ipaLines1,
                "ipaLines2"  : ipaLines2,
                "ipaLines3"  : ipaLines3,
                "ipaLines4"  : ipaLines4
                //obj.activeCompany
            }
            axios.post(url.IPAS +"&company="+ CompanyID, JSON.stringify(data), HRConfig)
                .then(function(response){  
                    if(response.data.No){
                        toastr.success("IPA No "+ response.data.No+" created" ); 
                        setIpaSaved(true);
                        setIpaNo(response.data.No)
                        setIsloading(false);
                    }else{
                        toastr.success("Could not IPA" )
                        setIsloading(false);
                    }
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    setIsloading(false);
                }) 
        }

        useEffect(() => {
            if (localStorage.getItem("authMildUser")) {
                const obj = JSON.parse(localStorage.getItem("authMildUser"));
                const EmployeeNo = obj.uid;
                setCompanyID(obj.activeCompany);
                axios.get(url.EMPLOYEES + "?$filter=No eq '"+ EmployeeNo +"'&company="+ obj.activeCompany, HRConfig)
                    .then(function(response){
                        if(response.data.value.length > 0){
                            setEmpNo(response.data.value[0].No);
                            setEmpName(response.data.value[0].FirstName + " " + response.data.value[0].MiddleName+ " " + response.data.value[0].LastName);
                            setEmpTitle(response.data.value[0].JobTitle);
                            setSupervisorNo(response.data.value[0].Appraiser)
                            axios.get(url.EMPLOYEES + "?$filter=No eq '"+ response.data.value[0].Appraiser +"'&company="+ obj.activeCompany, HRConfig).then((s)=>{
                                setSupervisorName(s.data.value[0].FirstName + " " + s.data.value[0].MiddleName+ " " + s.data.value[0].LastName)
                                setSupervisorTitle(s.data.value[0].JobTitle)
                            }).catch((se)=>console.log(se))
                            setUserError(false);
                        }else{
                            toastr.error("Employee Details Not Found in Business Central");
                        }
                    }).catch(function (error) {
                        toastr.error(error.response.data.error.message);
                        setUserError(true);
                        console.log(error);
                    })
               axios.get(url.COMPETENCIES +"?company=" +obj.activeCompany, HRConfig).then((r)=>{ setCompetencies(r.data.value) }).catch((e)=>{ console.log(e) })
    
            }
        },[]);

        
        return (
                <div className="page-content">
                    <MetaTags>
                    <title>Add IPAs | Bridge</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Performance Management" breadcrumbItem="Add Individual Performance Agreement" />
                        <div>
                  
                                <Modal isOpen={modal_ipa1} toggle={tog_ipa1} centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Add Technical Job Deliverables</h5>
                                    <button type="button" onClick={() => { setmodal_ipa1(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key Result Area</label>
                                                <textarea className="form-control" value={kra} onChange={(e)=>setKra(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Statement of target to be achieved</label>
                                                <textarea className="form-control" value={target} onChange={(e)=>setTarget(e.target.value)}/>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key Performance Indicator</label>
                                                <textarea className="form-control" value={kpi} onChange={(e)=>setKpi(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Resources Required</label>
                                                <textarea className="form-control" value={resources} onChange={(e)=>setResources(e.target.value)} />
                                            </div>
                                        </Col>
                                  </Row>
                                  </div>
                                  <div className="modal-footer justify-content-center align-items-center">
                                    <button type="button" onClick={() => {  tog_ipa1() }} className="btn btn-danger " data-dismiss="modal">Cancel</button>
                                    <button type="button" className="btn btn-success" onClick={addIPA1}>Add Line...</button>
                                  </div>
                                </Modal>
                                <Modal isOpen={modal_ipa2} toggle={tog_ipa2} centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Add Competence Targets</h5>
                                    <button type="button" onClick={() => { setmodal_ipa2(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Competence Code</label>
                                                <select className="form-select" value={cCode} onChange={(e)=>setCCode(e.target.value)}>
                                                    <option value=""></option>
                                                    {competencies.map((c,k)=>(
                                                        <option key={k} value={c.code}>{c.codeDescription}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Description</label>
                                                <textarea className="form-control" value={competenciesDescription} onChange={(e)=>setCompetenciesDescription(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Critical Attributes Targeted</label>
                                                <textarea className="form-control" value={attributes} onChange={(e)=>setAttributes(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Key Performance Indicator</label>
                                                <textarea className="form-control" value={kpi2} onChange={(e)=>setKpi2(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Resources Required</label>
                                                <textarea className="form-control" value={resources2} onChange={(e)=>setResources2(e.target.value)} />
                                            </div>
                                        </Col>
                                  </Row>
                                  </div>
                                  <div className="modal-footer justify-content-center align-items-center">
                                    <button type="button" onClick={() => {  tog_ipa2() }} className="btn btn-danger " data-dismiss="modal">Cancel</button>
                                    <button type="button" className="btn btn-success" onClick={addIPA2}>Add Line...</button>
                                  </div>
                                </Modal>
                                <Modal isOpen={modal_ipa3} toggle={tog_ipa3} centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Add Staff with People Management roles</h5>
                                    <button type="button" onClick={() => { setmodal_ipa3(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Support those reporting to you</label>
                                                <textarea className="form-control" value={support} onChange={(e)=>setSupport(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Planned Results What was the indicator of Coaching results</label>
                                                <textarea className="form-control" value={plannedResults} onChange={(e)=>setPlannedResults(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Actual Coaching Results achieved and impact</label>
                                                <textarea className="form-control" value={actualResults} onChange={(e)=>setActualResults(e.target.value)} />
                                            </div>
                                        </Col>
                                        
                                  </Row>
                                  </div>
                                  <div className="modal-footer justify-content-center align-items-center">
                                    <button type="button" onClick={() => {  tog_ipa3() }} className="btn btn-danger " data-dismiss="modal">Cancel</button>
                                    <button type="button" className="btn btn-success" onClick={addIPA3}>Add Line...</button>
                                  </div>
                                </Modal>
                                <Modal isOpen={modal_ipa4} toggle={tog_ipa4} centered>
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">Short Term Development Needs</h5>
                                    <button type="button" onClick={() => { setmodal_ipa4(false) }} className="close" data-dismiss="modal" aria-label="Close">
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Development Goal Identified</label>
                                                <textarea className="form-control" value={goal} onChange={(e)=>setGoal(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Learning Development Method</label>
                                                <textarea className="form-control" value={method} onChange={(e)=>setMethod(e.target.value)} />
                                            </div>
                                        </Col>
                                        <Col md={12}>
                                            <div className="mb-3">
                                                <label>Application</label>
                                                <textarea className="form-control" value={application} onChange={(e)=>setApplication(e.target.value)} />
                                            </div>
                                        </Col>
                                        
                                  </Row>
                                  </div>
                                  <div className="modal-footer justify-content-center align-items-center">
                                    <button type="button" onClick={tog_ipa4} className="btn btn-danger " data-dismiss="modal">Cancel</button>
                                    <button type="button" className="btn btn-success" onClick={addIPA4}>Add Line...</button>
                                  </div>
                                </Modal>
                        {(ipaSaved == false) ? (
 
                        <Row>
                        <Col  xl={3}>
                            <Timeline stage={0}/>
                            <Card>
                                    <CardBody>
                                    <Row>
                                        <Col sm={12}>
                                            <h5 className="text-primary">IPA Actions</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12}>
                                        <div className="d-grid">
                  
                                            <ButtonDropdown
                                                isOpen={btnprimary1}
                                                toggle={() => setBtnprimary1(!btnprimary1)}
                                                >
                                                <DropdownToggle tag="button" className="btn btn-primary">
                                                    + Add Deliverables <i className="mdi mdi-chevron-down" />
                                                </DropdownToggle>
                                                
                                                <DropdownMenu>
                                                    <DropdownItem onClick={tog_ipa1}>Add Technical Job Deliverables</DropdownItem>
                                                    <DropdownItem onClick={tog_ipa2}>Add Competence Targets</DropdownItem>
                                                    {/*<DropdownItem onClick={()=>tog_ipa3()}>Add Staff with People Management roles</DropdownItem>*/}
                                                    <DropdownItem onClick={()=>tog_ipa4()}>Add Short Term Development Needs</DropdownItem>
                                                    
                                                </DropdownMenu>
                                            
                                            </ButtonDropdown>
                                            </div>
                                        </Col>
                                    </Row>
                                    </CardBody>
                                </Card>

                        </Col>
                        <Col xl={9}>
                        <Card>
                            <CardBody>
                            <Row>
                                <Col sm={12}>
                                    <h5 className="text-primary">Details</h5>
                                        <hr/>
                                </Col>
                            </Row>
                       
                                    <Row>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Employee No</label>
                                            <input type="text" className="form-control" disabled={true}  value = {empNo} onChange={handleChange}  />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Employee Name</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={empName} onChange={handleChange}   />
                                        </div>
                                    </Col>
                                   
                              
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Title</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={empTitle} onChange={handleChange} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorNo} onChange={handleChange} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor Name</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorName} onChange={handleChange} />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                            <label>Supervisor Title</label>
                                            <input  type="text" className="form-control" disabled={true} defaultValue={supervisorTitle} onChange={handleChange} />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                            <Row>
                                <Col sm={12}>
                                    <h5 className="text-primary">IPA Details</h5>
                                        <hr/>
                                </Col>
                            </Row>
                                <Row>
                                <Col md={4}>
                                        <div className="mb-3">
                                        <label>Start Date</label>
                                        <Flatpickr
                                            className="form-control"
                                            options={{
                                                altInput: true,
                                                altFormat: "F j, Y",
                                                dateFormat: "Y-m-d",
                                                disabled: true
                                            }}
                                            onChange={(date)=>setStartDate(date)}
                                        />
                                        
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>End Date</label>
                                        <Flatpickr
                                            className="form-control"
                                            options={{
                                                altInput: true,
                                                altFormat: "F j, Y",
                                                dateFormat: "Y-m-d",
                                                disabled: true
                                            }}
                                            onChange={(date)=>setEndDate(date)}
                                        />
                                        </div>
                                    </Col>
                                    <Col md={4}>
                                        <div className="mb-3">
                                        <label>Type of Performance Appraisal</label>
                                        <select className="form-select" onChange={(e)=>setType(e.target.value)}>
                                                    <option value="">Select</option>
                                                    {apType.map((a,k)=>(
                                                        <option value={a} key={k}>{a}</option>
                                                    ))}
                                                </select>
                                        
                                        </div>
                                    </Col>
                                    </Row>
                                
                             
                                    <Row>
                                        <Col sm={12}>
                                            <h5 className="text-primary">Technical Job Deliverables ({ipaLines1.length})</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    {(ipaLines1.map((i,k)=>(
                                        <Row key={k}>
                                            <Col lg={10}>
                                                <div className="p-4">
                                                    <h5 className="text-primary">Line {k+1}</h5>

                                                    <div className="text-muted">
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Key Result Area: </strong><br/>{i.KeyResultArea}
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Statement of target to be achieved: </strong><br/>{i.StatementofTargettobeachieved} 
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Key Performance Indicator: </strong><br/>{i.KeyPerformanceIndicator}
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Resources Required: </strong><br/>{i.ResourcesandSupportRequiredforachievementsettargetsandgoals}
                                                    </p>
                                                    
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col lg={2} className="align-self-center">
                                                <div className="form-floating mb-0">
                                                <input
                                                    type="button"
                                                    className="btn btn-primary"
                                                    value="Remove"
                                                    onClick={() => remove1(k)}
                                                />
                                                </div>
                                            </Col>
                                        </Row>
                                    )))}
                          
                                    <Row>
                                        <Col sm={12}>
                                            <h5 className="text-primary">Competence Targets ({ipaLines2.length})</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    {(ipaLines2.map((i,k)=>(
                                        <Row key={k}>
                                            <Col lg={10}>
                                                <div className="p-4">
                                                    <h5 className="text-primary">Line {k+1}</h5>

                                                    <div className="text-muted">
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Competence Code: </strong><br/>{i.CompetenceCode} 
                                                    </p>
                                                    {/*<p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Description: </strong><br/>{i.CompetenciesDescription} 
                                                    </p>*/}
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Critical Attributes Targeted: </strong><br/>{i.CriticalAttributestargetedundereachcompetence}
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Key Performance Indicator: </strong><br/>{i.KeyPerformanceIndicator}
                                                    </p>
                                                
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col lg={2} className="align-self-center">
                                                <div className="form-floating mb-0">
                                                <input
                                                    type="button"
                                                    className="btn btn-primary"
                                                    value="Remove"
                                                    onClick={() => remove2(k)}
                                                />
                                                </div>
                                            </Col>
                                        </Row>
                                    )))}
                                    {/*<Row>
                                        <Col sm={12}>
                                            <h5 className="text-primary">Staff with People Management roles ({ipaLines3.length})</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    {(ipaLines3.map((i,k)=>(
                                        <Row key={k}>
                                            <Col lg={10}>
                                                <div className="p-4">
                                                    <h5 className="text-primary">Line {k+1}</h5>

                                                    <div className="text-muted">
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>What was done to Support those reporting to You: </strong><br/>{i.Supportthosereportingtoyoutoimplementthisyearsperformanceandlearninganddevelopmentobjectives} 
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Planned results: </strong><br/>{i.PlannedResultsWhatwastheindicatorofCoachingresults}
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Actual Coaching results: </strong><br/>{i.ActualCoachingResultsWhatwasachievedandimpact}
                                                    </p>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col lg={2} className="align-self-center">
                                                <div className="form-floating mb-0">
                                                <input
                                                    type="button"
                                                    className="btn btn-primary"
                                                    value="Remove"
                                                    onClick={() => remove3(k)}
                                                />
                                                </div>
                                            </Col>
                                        </Row>
                                    )))}*/}
                            
                                    <Row>
                                        <Col sm={12}>
                                            <h5 className="text-primary">Short Term Development Needs ({ipaLines4.length})</h5>
                                             <hr/>
                                        </Col>
                                    </Row>
                                    {(ipaLines4.map((i,k)=>(
                                        <Row key={k}>
                                            <Col lg={10}>
                                                <div className="p-4">
                                                    <h5 className="text-primary">Line {k+1}</h5>

                                                    <div className="text-muted">
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Development goal: </strong><br/>{i.DevelopmentGoalsIdentifiedlearningdevelopmentareas} 
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Learning development method: </strong><br/>{i.LearningDevelopmentMethodsHowwilltheLearningandDevelopmentbeachieved}
                                                    </p>
                                                    <p className="mb-1">
                                                        <i className="mdi mdi-circle-medium align-middle text-primary me-1"/>{" "}
                                                        <strong>Application: </strong><br/>{i.ApplicationWhatistheexpectedchangeinperformanceafteracquiringtheidentifiedskills}
                                                    </p>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col lg={2} className="align-self-center">
                                                <div className="form-floating mb-0">
                                                <input
                                                    type="button"
                                                    className="btn btn-primary"
                                                    value="Remove"
                                                    onClick={() => remove4(k)}
                                                />
                                                </div>
                                            </Col>
                                        </Row>
                                    )))}
                                    <Row className='justify-content-center'>
                                       
                                        <Col md={6}>
                                            <div className="d-grid gap-2">
                                                <button
                                                type="button"
                                                className="btn btn-success"
                                                onClick={handleSaveIPA}
                                                >
                                                Save IPA details...
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            </Col>
                            

                   
                        </Row>
                        ):(
                            <Row className="d-flex justify-content-center">
                                <Col lg={8} >
                                <Card outline color="success" className="border">
                                    <CardBody>
                                    <CardTitle className="mb-4 text-white">
                                        
                                    </CardTitle>
                                    <CardText>
                                        
                                    </CardText>
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                                        </div>
                                        <div>
                                        <h5>Saved</h5>
                                        <p className="text-muted">
                                                Individual Performance Agreement <strong>{ipaNo}</strong> Saved!
                                        </p>
                                        </div>
                                    </div>
                                    </CardBody>
                                </Card>
                                </Col>
                            </Row>
                        )}
                        </div>


                        
                           

                    </Container>
                </div>
         

        );
    }

export default IPAAdd;